import { AdminSearchApplications } from "../components/AdminSearchApplications";
import CustForm from "../components/CustForm";
export function AdminAnnulReg() {
    document.title = `Търсене - Анулиране`;

    return (
        <main id="main" className="main">

            <div className="pagetitle">
                <h1 className="use-font">Анулиране на заявления</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Анулиране на заявления</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">

                <div className="row">

                    <div className="col-lg-12">
                        <div className="row">
                            <AdminSearchApplications action='cancel'/>
                        </div>
                    </div>

                </div>

            </section>

        </main>
    )
}

export default AdminAnnulReg;